import classNames from 'classnames';
import * as React from 'react';
import ClanRole from '../ClanRole/ClanRole.js';
import styles from './MemberName.module.scss.js';

var MemberName = React.memo(function (props) {
    var _a;
    var classNameMember = classNames(styles.member, props.className, (_a = {},
        _a[styles.isInline] = props.isInline,
        _a));
    var role = props.role ? React.createElement(ClanRole, { key: "member_name_role", role: props.role }) : null;
    return (React.createElement("span", { className: classNameMember },
        role,
        React.createElement("span", { key: "member_name", className: styles.name }, props.name)));
});

export { MemberName as default };
//# sourceMappingURL=MemberName.js.map
